import React from 'react';
import { useNavigate } from 'react-router-dom';

function TeamCard({ teamMembers = [] }) {
  const navigate = useNavigate();
  
  // Take at most 7 team members for the circle
  const displayedMembers = teamMembers.slice(0, 7);
  
  // Navigate to team directory page
  const goToTeamDirectory = () => {
    navigate('/therapist/team');
  };
  
  return (
    <div
      style={teamCardStyle}
      onClick={goToTeamDirectory}
    >
      <h3 style={cardTitle}>Your Team</h3>
      
      {displayedMembers.length > 0 ? (
        <>
          <div style={teamCircleContainerStyle}>
            {displayedMembers.map((member, index) => {
              // Calculate position in circle
              const angle = (index * (2 * Math.PI / displayedMembers.length)) - Math.PI/2;
              const radius = 70; // Radius of the circle in pixels
              
              // Calculate x, y position on the circle
              const x = radius * Math.cos(angle);
              const y = radius * Math.sin(angle);
              
              return (
                <div 
                  key={member.therapist_id || index}
                  style={{
                    ...memberPhotoContainerStyle,
                    transform: `translate(${x}px, ${y}px)`
                  }}
                >
                  {member.photo_url ? (
                    <img 
                      src={member.photo_url} 
                      alt={`${member.first_name} ${member.last_name}`} 
                      style={memberPhotoStyle} 
                    />
                  ) : (
                    <div style={{
                      ...memberPhotoStyle,
                      backgroundColor: '#e0e0e0',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.8rem',
                      color: '#666'
                    }}>
                      {member.first_name ? member.first_name.charAt(0) : ''}
                      {member.last_name ? member.last_name.charAt(0) : ''}
                    </div>
                  )}
                </div>
              );
            })}
            
            {/* If there are more than 7 team members, show a +N indicator */}
            {teamMembers.length > 7 && (
              <div style={extraMembersStyle}>
                +{teamMembers.length - 7}
              </div>
            )}
          </div>
          
          <p style={cardSubtext}>
            {teamMembers.length} team members
          </p>
        </>
      ) : (
        <div style={emptyStateStyle}>
          <p>No team members found</p>
        </div>
      )}
      
      <p style={viewTeamTextStyle}>
        Click to view team directory
      </p>
    </div>
  );
}

// Styles
const teamCardStyle = {
  borderRadius: '12px',
  padding: '1.5rem',
  backgroundColor: 'white',
  boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  border: '1px solid #e0e0e0',
  height: '100%',
  ':hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0,0,0,0.15)'
  }
};

const cardTitle = {
  fontSize: '1.4rem',
  margin: '0 0 1.5rem 0',
  textAlign: 'center'
};

const teamCircleContainerStyle = {
  position: 'relative',
  width: '180px',
  height: '180px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '1rem'
};

const memberPhotoContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(0, 0)', // Will be overridden for each member
  transition: 'transform 0.3s ease'
};

const memberPhotoStyle = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  objectFit: 'cover',
  border: '2px solid #4CAF50',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  transition: 'transform 0.2s ease',
  ':hover': {
    transform: 'scale(1.1)'
  }
};

const extraMembersStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  backgroundColor: '#4CAF50',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold',
  fontSize: '0.9rem',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

const cardSubtext = {
  margin: '0 0 0.5rem 0',
  fontSize: '1rem',
  color: '#666',
  textAlign: 'center'
};

const emptyStateStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem 0',
  color: '#999',
  flex: 1
};

const viewTeamTextStyle = {
  fontSize: '0.9rem',
  color: '#4CAF50', 
  fontWeight: 'bold',
  margin: 'auto 0 0 0',
  textAlign: 'center',
  padding: '0.5rem 0'
};

export default TeamCard;